import React from "react";

const DateRangePicker = ({onSelectDate, dateRange}) => {
  const handleStartDateChange = (event) => {
    const value = event.target.value;
    onSelectDate("startDate", value);
  };

  const handleEndDateChange = (event) => {
    const value = event.target.value;
    onSelectDate("endDate", value);
  };
  return (
    <>
      <form className="flex">
        <label className="inline-flex flex-col md:flex-row md:items-center font-body">
          <p className="font-bold text-gray-900 text-sm mr-2">Fecha</p>
          <div>
            <input
              className="mr-2 w-28 md:w-32 font-light text-sm border-b border-b-gray-200"
              type="date"
              value={dateRange.startDate}
              onChange={handleStartDateChange}
              placeholder="Desde"
            />
            <input
              className="mr-2 w-28 md:w-32 font-light text-sm border-b border-b-gray-200"
              type="date"
              value={dateRange.endDate}
              onChange={handleEndDateChange}
              placeholder="Hasta"
            />
          </div>
        </label>
      </form>
    </>
  );
};

export default DateRangePicker;
